import { Box, IconButton, Typography, useTheme } from '@mui/material';
import { useEffect, useRef, useState } from 'react';
import { API_DELETE, API_GET, DBRequest, useConfig } from '../../api/api';
import { useTranslation } from 'react-i18next';
import { tokens } from '../../global/theme/tokens';
import DeleteIcon from '@mui/icons-material/Delete';
import ExoAlert from '../../components/exo/ExoAlert';
import BookmarkIcon from '@mui/icons-material/Bookmark';

const ExoPresets = ({ path }) => {
  const config = useConfig();

  const [presets, setPresets] = useState(null);

  useEffect(() => {
    DBRequest({
      config,
      path: path,
      method: API_GET,
      onResponse: setPresets,
      debug: true,
    });
  }, [config]);

  // delete
  function handleDelete(id) {
    DBRequest({
      config,
      path: `${path}/${id}`,
      method: API_DELETE,
      onResponse: () => handleRemoveDeletedPreset(id),
    });
  }
  function handleRemoveDeletedPreset(id) {
    const newPresets = presets.data.filter((preset) => preset.id !== id);
    setPresets({ ...presets, data: newPresets });
  }

  // update functionality if needed for future then refer ExoCategories
  return (
    <>
      <Box className="flex flex-col gap-2 w-full">
        {presets &&
          presets.data.map((preset, index) => (
            <PresetItem preset={preset} key={index} onDelete={handleDelete} />
          ))}
      </Box>
    </>
  );
};

const PresetItem = ({ preset, onDelete, onEdit }) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const colors = tokens(theme.palette.mode, theme.palette.colorTheme);
  const [alertOpen, setAlertOpen] = useState(false);
  const deleteAlert = {
    message: t(
      'Are you sure you want to delete the preset? All assigned items will lose this preset!'
    ),
    submitLabel: 'Yes',
    cancelLabel: 'No',
  };

  return (
    <Box
      className="p-2 rounded-lg flex flex-row gap-2 backdrop-blur-lg items-center"
      sx={{
        bgcolor: colors.glass,
        '& .delButton': {
          color: colors.error,
          border: `1px solid ${colors.error}80`,
          opacity: 1,
        },
        '& .delButton:hover': {
          bgcolor: colors.error + '30',
        },
      }}
    >
      <Box className="flex flex-row items-center gap-2 flex-1">
        {preset?.icon ? (
          <img
            src={preset.icon.temporaryUrl}
            alt={`${preset.title} icon`}
            className="w-8 h-8 object-contain"
          />
        ) : (
          <IconButton>
            <BookmarkIcon />
          </IconButton>
        )}

        <Box className="flex flex-col gap-1">
          <Typography>{preset.title}</Typography>
          {preset.data && (
            <Typography variant="h6">{preset.data.name}</Typography>
          )}
        </Box>
      </Box>

      <Box>
        {/* <IconButton onClick={() => onEdit(preset)}>
      <EditIcon />
    </IconButton> */}
        <IconButton
          size="small"
          className="delButton"
          aria-label="delete preset"
          onClick={() => setAlertOpen(true)}
        >
          <DeleteIcon />
        </IconButton>
      </Box>

      {/* Alert Dialog */}
      <ExoAlert
        open={alertOpen}
        onSubmit={() => {
          setAlertOpen(false);
          onDelete(preset.id);
        }}
        onClose={() => setAlertOpen(false)}
        alert={deleteAlert}
      />
    </Box>
  );
};

export default ExoPresets;
